import React, { Component } from "react";
import { Redirect } from "react-router-dom";
//Service import
import service from '../services'
import moment from 'moment'
let sub;
export default class Tablist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activetab: props.active ,
      activetabNF:props.activeNF,
      data: [
        {
          label: "FILMS",
          Content: "This is content for Tab 1",
        },
        {
          label: "EVENTS",
          Content: "This is content for Tab 2",
        },
        {
          label: "NEW FRONTIER",
          Content: "This is content for Tab 3",
        },
        {
          label: "INSTITUTE EVENTS",
          Content: "This is content for Tab 4",
        }
      ],
      dataCredits: [
        {
          label: "FILMS",
          Content: "This is content for Tab 1",
        },
        // {
        //   label: "NEW FRONTIER",
        //   Content: "This is content for Tab 3",
        // },
      ],
    };
    this.apiserve = new service();
  }

  TabClick = (index) => {
    this.setState({
      activetab: index,
    }, () =>{
      this.updatedAt()
    });
  };

  TabClickNF = (label) => {
      this.setState({
        activetabNF: label,
      }, () =>{
        this.updatedAt()
      });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
}

componentDidMount() {
  this.updatedAt();
  sub = this.apiserve.getevent().subscribe((response) => {
    switch(response.event){
      case "film|getLastUpdated":
        this.setState({
          getLastUpdated:response.data
        })
        break;

        default:break;
    }
  })
}

updatedAt = () => {
  var data={}
  if(this.state.activetab === 0){
      data.type=4
  }
  if(this.state.activetab === 1){
      data.type=8
  }
  if(this.state.activetab === 2){
      data.type=10
  }
  if(this.state.activetab === 3){
      data.type=18
  }
  if(this.props.name === 'awardCategory'){
    data.type=21
  }
  if(this.props.name === 'screeningType'){
    data.type=22
  }
  if(this.props.name === 'genre'){
    data.type=12
  }
  if(this.props.name === 'interest'){
    data.type=5
  }
  if(this.props.name === 'credit'){
    data.type=7
  }
  this.apiserve.sendevent("film|getLastUpdated", data);
}
  render() {
    const {getLastUpdated} = this.state
        var updateAt = new Date (getLastUpdated && getLastUpdated.updatedAt)
        var hour = moment(updateAt).format('h')
        var minutes = moment(updateAt).format('mm')
        var state = moment(updateAt).format('A')
        var updatedBy = getLastUpdated && getLastUpdated.updatedBy
    return (
      <>
        <ul className="fpg_admin_tab disp_flex">
          {this.state.activetabNF === 'FILMS' || this.state.activetabNF === "NEW FRONTIER"  ?
          this.state.dataCredits &&
            this.state.dataCredits.map((list, index) => {
              return (
                <li
                key={index}
                className={this.state.activetabNF === list.label ? "active" : ""}
                onClick={() => this.TabClickNF(list.label)}
              >
                <p> <div>{list.label}</div></p>
              </li>
            );
          }) : 
          this.state.activetab === "Film" ? (
            <li className="active">
              <p><div className="uppercase">{this.state.activetab}</div></p>
            </li>
          ) : 
          !!this.props?.screeningTypes?.length > 0 ? (
            this.props.screeningTypes.map(({ locationType, label }, index) => {
              return (
                <li
                  key={index}
                  className={this.state.activetab === locationType ? "active" : ""}
                  onClick={() => { this.TabClick(locationType); this.props.handleChangeTab(locationType); }}
                >
                  <p><div>{label}</div></p>
                </li>
              );
            })
          ) : ( 
            this.state.data &&
            this.state.data.map((list, index) => {
              return (
                list.label === 'NEW FRONTIER' ? '' :
                <li
                  className={this.state.activetab === index ? "active" : ""}
                  onClick={() => this.TabClick(index)}
                >
                  <p> <div>{list.label}</div></p>
                </li>
              );
            })
          )
         
        }
        </ul>
        <div class="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
          <p></p>
          {this.state.getLastUpdated && this.state.getLastUpdated.updatedAt === undefined ? '' :
            <p class="update_date">Last Update: {hour}:{minutes} {state} - {moment(updateAt).format('MM/DD/YYYY')} Last Updated By: {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}</p>
          }
        </div>
        {this.state.activetabNF === 'FILMS'? <Redirect to="/filmcreditlebel" /> : ""}
        {this.state.activetabNF === "NEW FRONTIER" ? <Redirect to="/new-frontier-creditlebel" /> : ""}
        {this.state.activetab === 0 ? <Redirect to="/filmcategory" /> : ""}
        {this.state.activetab === 1 ? (
          <Redirect to="/eventcategory" />
        ) : (
          ""
        )}
        {this.state.activetab === 2 ? (
          <Redirect to="/newfrontiercategory" />
        ) : (
          ""
        )}
        {this.state.activetab === 3 ? (
          <Redirect to="/othereventscategory" />
        ) : (
          ""
        )}
      </>
    );
  }
}
